import FocusIcon from "@/assets/img/today/horoscope/features_focus.svg?react";
import TroublesIcon from "@/assets/img/today/horoscope/features_troubles.svg?react";

import {
  HOROSCOPE_FEATURES,
  type FeatureCard,
} from "../../config/horoscope-content";

/** Focus / Troubles cards in a horizontal scroller. Ported from Horoscope FeaturesSlider. */
export function FeaturesSlider({
  focusTags,
  troublesTags,
}: {
  focusTags: string[];
  troublesTags: string[];
}) {
  return (
    <div className="flex items-start gap-4 overflow-x-auto px-4 pt-6 [scrollbar-width:none]">
      <Card
        card={{ ...HOROSCOPE_FEATURES.focus, tags: focusTags }}
        icon={<FocusIcon />}
      />
      <Card
        card={{ ...HOROSCOPE_FEATURES.troubles, tags: troublesTags }}
        icon={<TroublesIcon />}
      />
    </div>
  );
}

function Card({ card, icon }: { card: FeatureCard; icon: React.ReactNode }) {
  return (
    <div className="flex w-[320px] min-w-[320px] flex-col items-start gap-4 rounded-3xl bg-gradient-to-bl from-purple-light/10 to-purple-light/5 px-4 pb-6 pt-4">
      <span className="[&_svg]:size-14">{icon}</span>
      <div className="flex flex-col gap-2">
        <h3 className="font-display text-xl font-medium text-purple-light">
          {card.title}
        </h3>
        <p className="font-body text-base text-purple-light/70">
          {card.description}
        </p>
      </div>
      <div className="flex flex-wrap gap-[5px]">
        {card.tags.map((tag) => (
          <span
            key={tag}
            className="whitespace-nowrap rounded-[23px] border border-purple-light/20 px-3 py-1.5 font-body text-sm text-purple-light/70"
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
}
